(function () {
  'use strict';

  function initGallery(root) {
    if (root.dataset.galleryReady) return;
    var main = root.querySelector('.mel-gallery__main img');
    if (!main) return;
    root.dataset.galleryReady = 'true';
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.mel-gallery__thumb'));
    var section = root.closest('.mel-product-main');
    var colorPicker = section && section.querySelector('[data-mel-color-option]');
    var colorName = colorPicker && colorPicker.querySelector('[data-mel-selected-color]');
    var mediaData = root.querySelector('[data-mel-color-media]');
    var mediaByColor = {};
    try { mediaByColor = mediaData ? JSON.parse(mediaData.textContent) : {}; } catch (e) { /* Keep the gallery usable. */ }
    var selectedColor;

    function showImage(thumb) {
      if (!thumb || thumb.closest('li').hidden) return;
      var src = thumb.getAttribute('data-full-src');
      if (!src) return;
      if (main.dataset.mediaId !== thumb.dataset.mediaId) {
        main.src = src;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
      }
      main.dataset.mediaId = thumb.dataset.mediaId;
      main.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (item) {
        if (item === thumb) {
          item.setAttribute('data-active', 'true');
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('data-active');
          item.removeAttribute('aria-current');
        }
      });
    }

    function updateColor() {
      var checked = colorPicker && colorPicker.querySelector('input:checked');
      if (!checked || selectedColor === checked.value) return;
      selectedColor = checked.value;
      if (colorName) colorName.textContent = checked.value.replace(/-/g, ' ');
      var ids = mediaByColor[selectedColor];
      thumbs.forEach(function (thumb) {
        thumb.closest('li').hidden = Array.isArray(ids) && ids.indexOf(thumb.dataset.mediaId) === -1;
      });
      var visible = thumbs.filter(function (thumb) { return !thumb.closest('li').hidden; });
      var label = checked.closest('label');
      var featuredSrc = label && label.getAttribute('data-variant-img');
      var featured = visible.find(function (thumb) { return thumb.getAttribute('data-full-src') === featuredSrc; });
      showImage(featured || visible[0]);
      // A single-image product has no thumbnail strip, but its color still changes.
      if (!visible.length && featuredSrc) {
        main.src = featuredSrc;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.alt = checked.getAttribute('aria-label') || checked.value;
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showImage(thumb); });
    });
    if (colorPicker) colorPicker.addEventListener('change', updateColor);
    updateColor();
  }

  function init(scope) {
    scope.querySelectorAll('.mel-gallery').forEach(initGallery);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
